import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Environment, ENVIRONMENT } from '@classifieds-sell/environment';
import {
    IFundSources,
    IPingTransactionDetails,
    IRemoveFundSourceResponse,
    ITopUpAccountRequest,
    ITopUpAccountResponse
} from '@classifieds-sell/datalayer';

@Injectable({
    providedIn: 'root'
})
export class PingService {
    constructor(
        private httpClient: HttpClient,
        @Inject(ENVIRONMENT) private env: Environment
    ) {}

    public getFundSources(): Observable<IFundSources> {
        return this.httpClient.get<IFundSources>(
            `${this.env.apiUrl}/Ping/GetFundSources`,
            {
                withCredentials: true
            }
        );
    }

    public addCreditPaymentWithDetails(
        amount: number,
        details: IPingTransactionDetails
    ): Observable<ITopUpAccountResponse> {
        const request: ITopUpAccountRequest = {
            amount: amount,
            pingTransactionDetails: details
        };

        return this.httpClient.post<ITopUpAccountResponse>(
            `${this.env.apiUrl}/Ping/TopUpAccount`,
            request,
            { withCredentials: true }
        );
    }

    public removeFundSource(
        type: string,
        fundSourceId: number
    ): Observable<IRemoveFundSourceResponse> {
        return this.httpClient.delete<IRemoveFundSourceResponse>(
            `${this.env.apiUrl}/Ping/RemoveFundSource/${type}/${fundSourceId}`,
            { withCredentials: true }
        );
    }
}
